import { createRocket } from "../_util/create-rocket";

export const H1 = createRocket("H1", "h1.@{prefix}-h1");
export const H2 = createRocket("H2", "h2.@{prefix}-h2");
export const H3 = createRocket("H3", "h3.@{prefix}-h3");
export const H4 = createRocket("H4", "h4.@{prefix}-h4");
export const H5 = createRocket("H5", "h5.@{prefix}-h5");
export const H6 = createRocket("H6", "h6.@{prefix}-h6");
